import React, { useContext, useEffect, useState } from "react";
import Drawer from "@material-ui/core/Drawer";

import Picker from "bodycodi/cmap/app/components/common/picker";
import PickerHeader from "bodycodi/cmap/app/components/common/pickerHeader";
import { DispatchContext, StateContext } from "bodycodi/cmap/app/components/common/context";

interface SelectTimePop {
  typeName: "시작" | "종료";
  startTime: any;
  setStartTime: any;
  endTime: any;
  setEndTime: any;
}
function SelectTimePop({ typeName, startTime, endTime, setStartTime, setEndTime }: SelectTimePop) {
  const { dispatch } = useContext(DispatchContext);
  const { state } = useContext(StateContext);
  const [current, setCurrent] = useState({
    startNo: 0,
    endNo: 0,
    hour: 0,
    min: 0,
  });

  useEffect(() => {
    if (typeName === "시작") {
      setCurrent({
        startNo: startTime.hour,
        endNo: startTime.min / 5,
        hour: startTime.hour,
        min: startTime.min,
      });
    } else {
      setCurrent({
        startNo: endTime.hour,
        endNo: endTime.min / 5,
        hour: endTime.hour,
        min: endTime.min,
      });
    }
  }, [typeName, startTime, endTime]);

  const handleChangeHour = (i: number, v: any) => {
    setCurrent((previousValue) => ({
      ...previousValue,
      startNo: v.value,
      hour: parseInt(v.text, 10),
    }));
  };

  const handleChangeMinute = (i: number, v: any) => {
    setCurrent((previousValue) => ({
      ...previousValue,
      endNo: v.value,
      min: parseInt(v.text, 10),
    }));
  };

  const handleClose = () => {
    if (typeName === "시작") {
      setCurrent({
        startNo: startTime.hour,
        endNo: startTime.min / 5,
        hour: startTime.hour,
        min: startTime.min,
      });
    } else {
      setCurrent({
        startNo: endTime.hour,
        endNo: endTime.min / 5,
        hour: endTime.hour,
        min: endTime.min,
      });
    }
    dispatch({ type: "POP_UP_OPEN", id: "NOTIFICATION_POP", open: { selectTimePop: false } });
  };

  const handleConfirm = () => {
    if (typeName === "시작") {
      setStartTime((previousValue: any) => ({
        ...previousValue,
        hour: current.hour,
        min: current.hour === 23 && current.min === 55 ? 50 : current.min,
      }));
    } else {
      setEndTime((previousValue: any) => ({
        ...previousValue,
        hour: current.hour,
        min: current.min,
      }));
    }
    dispatch({ type: "POP_UP_OPEN", id: "NOTIFICATION_POP", open: { selectTimePop: false } });
  };

  return (
    <Drawer anchor="bottom" open={state.selectTimePop} onClose={handleClose} className="picker-pop">
      <PickerHeader title="시간 선택" onClose={handleClose} />
      <div className="picker-body">
        <div className="picker-effect">
          <div className="picker-wrap">
            <Picker
              data={[
                { value: 0, text: "00" },
                { value: 1, text: "01" },
                { value: 2, text: "02" },
                { value: 3, text: "03" },
                { value: 4, text: "04" },
                { value: 5, text: "05" },
                { value: 6, text: "06" },
                { value: 7, text: "07" },
                { value: 8, text: "08" },
                { value: 9, text: "09" },
                { value: 10, text: "10" },
                { value: 11, text: "11" },
                { value: 12, text: "12" },
                { value: 13, text: "13" },
                { value: 14, text: "14" },
                { value: 15, text: "15" },
                { value: 16, text: "16" },
                { value: 17, text: "17" },
                { value: 18, text: "18" },
                { value: 19, text: "19" },
                { value: 20, text: "20" },
                { value: 21, text: "21" },
                { value: 22, text: "22" },
                { value: 23, text: "23" },
              ]}
              onChange={handleChangeHour}
              index={0}
              current={current.startNo}
              height={40}
              align="right"
            />
            <div className="time-between">
              <div>:</div>
            </div>
            <Picker
              data={[
                { value: 0, text: "00" },
                { value: 1, text: "05" },
                { value: 2, text: "10" },
                { value: 3, text: "15" },
                { value: 4, text: "20" },
                { value: 5, text: "25" },
                { value: 6, text: "30" },
                { value: 7, text: "35" },
                { value: 8, text: "40" },
                { value: 9, text: "45" },
                { value: 10, text: "50" },
                { value: 11, text: "55" },
              ]}
              onChange={handleChangeMinute}
              index={0}
              current={current.endNo}
              height={40}
              align="left"
            />
            <div className="center-background"></div>
          </div>
        </div>
      </div>
      <div className="picker-footer">
        <div className="confirm-btn" color="#fff" onClick={handleConfirm}>
          확인
        </div>
      </div>
    </Drawer>
  );
}

export default SelectTimePop;
